import { Routes, Route, useLocation, Navigate } from 'react-router-dom';
import Header from './Header';
import Register from './Register';
import Home from './Home';
import Menu from './Menu';
import Footer from './Footer';
import AddConst from './AddConst';
import AddBooth from './AddBooth';
import AddBoothReport from './AddBoothReport';
import News from './News';
import Events from './Events';
import ToDo from './ToDo';
import EditToDo from './EditToDo';
import ChangePassword from './ChangePassword';
import Login from './Login';
import AddStreet from "./AddStreet";
import AddHouse from "./AddHouse";
import AddVoter from "./AddVoter";
import AddVolunteer from "./AddVolunteer";

// =======================
// CAMPAIGN & REPORTS
// =======================
import BoothReport from "./BoothReport";
import AddVisit from "./AddVisit";
import AddBoothDailyUpdate from "./AddBoothDailyUpdate";

// =======================
// ELECTION DAY
// =======================
import AddBoothTurnout from "./AddBoothTurnout";
import AddElectionIncident from "./AddElectionIncident";

// =======================
// ELECTION MANAGEMENT (NEW)
// =======================
import AddElection from "./AddElection";
import AddParty from "./AddParty";
import AddResult from "./AddResult";
import AddPartyVote from "./AddPartyVote";

// =======================
// DASHBOARDS
// =======================
import LiveDashboard from "./LiveDashboard";

import PrivateRoute from './PrivateRoute';

function Main() {
  const location = useLocation();

  const hideHeader = location.pathname === "/user-login";

  return (
    <div className="App">
      {!hideHeader && <Header />}

      <Routes>

        {/* =======================
            PUBLIC ROUTES
        ======================= */}
        <Route path="/user-login" element={<Login />} />
        <Route path="/user-register" element={<Register />} />

        {/* =======================
            PROTECTED ROUTES
        ======================= */}
        <Route element={<PrivateRoute />}>

          <Route path="/" element={<Home />} />
          <Route path="/admin-menu" element={<Menu />} />
          <Route path="/change-password" element={<ChangePassword />} />

          {/* MASTER DATA */}
          <Route path="/add-const" element={<AddConst />} />
          <Route path="/add-booth" element={<AddBooth />} />
          <Route path="/add-streets" element={<AddStreet />} />
          <Route path="/add-houses" element={<AddHouse />} />
          <Route path="/add-voters" element={<AddVoter />} />

          {/* FIELD WORK */}
          <Route path="/booth-report" element={<AddBoothReport />} />
          <Route path="/add-volunteers" element={<AddVolunteer />} />
          <Route path="/add-visits" element={<AddVisit />} />
          <Route path="/booth-daily-update" element={<AddBoothDailyUpdate />} />

          {/* ELECTION DAY */}
          <Route path="/booth-turnout" element={<AddBoothTurnout />} />
          <Route path="/election-incidents" element={<AddElectionIncident />} />

          {/* =======================
              ELECTION MANAGEMENT
          ======================= */}
          <Route path="/add-election" element={<AddElection />} />
          <Route path="/add-party" element={<AddParty />} />
          <Route path="/add-result" element={<AddResult />} />
          <Route path="/add-party-vote" element={<AddPartyVote />} />

          {/* DASHBOARD */}
          <Route path="/live-dashboard" element={<LiveDashboard />} />

          {/* UTILITIES */}
          <Route path="/news" element={<News />} />
          <Route path="/events" element={<Events />} />
          <Route path="/todolist" element={<ToDo />} />
          <Route path="/edit-todolist/:id" element={<EditToDo />} />

        </Route>

        {/* =======================
            FALLBACK
        ======================= */}
        <Route path="*" element={<Navigate to="/user-login" replace />} />

      </Routes>

      {!hideHeader && <Footer />}
    </div>
  );
}

export default Main;